var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -4 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_7981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 0H-0.000244141V20H27.9998V0Z",
    fill: "url(#paint0_linear_1310_7981)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000244141 0H27.9998V1.33333H-0.000244141V0ZM-0.000244141 2.66667H27.9998V4H-0.000244141V2.66667ZM-0.000244141 5.33333H27.9998V6.66667H-0.000244141V5.33333ZM-0.000244141 8H27.9998V9.33333H-0.000244141V8ZM-0.000244141 10.6667H27.9998V12H-0.000244141V10.6667ZM-0.000244141 13.3333H27.9998V14.6667H-0.000244141V13.3333ZM-0.000244141 16H27.9998V17.3333H-0.000244141V16ZM-0.000244141 18.6667H27.9998V20H-0.000244141V18.6667Z",
    fill: "url(#paint1_linear_1310_7981)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0H-0.000244141V9.33333H11.9998V0Z",
    fill: "url(#paint2_linear_1310_7981)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99992 2.66666C1.63173 2.66666 1.33325 2.36818 1.33325 1.99999C1.33325 1.63181 1.63173 1.33333 1.99992 1.33333C2.36811 1.33333 2.66659 1.63181 2.66659 1.99999C2.66659 2.36818 2.36811 2.66666 1.99992 2.66666ZM4.66659 2.66666C4.2984 2.66666 3.99992 2.36818 3.99992 1.99999C3.99992 1.63181 4.2984 1.33333 4.66659 1.33333C5.03477 1.33333 5.33325 1.63181 5.33325 1.99999C5.33325 2.36818 5.03477 2.66666 4.66659 2.66666ZM7.33325 2.66666C6.96506 2.66666 6.66658 2.36818 6.66658 1.99999C6.66658 1.63181 6.96506 1.33333 7.33325 1.33333C7.70144 1.33333 7.99992 1.63181 7.99992 1.99999C7.99992 2.36818 7.70144 2.66666 7.33325 2.66666ZM9.99992 2.66666C9.63173 2.66666 9.33325 2.36818 9.33325 1.99999C9.33325 1.63181 9.63173 1.33333 9.99992 1.33333C10.3681 1.33333 10.6666 1.63181 10.6666 1.99999C10.6666 2.36818 10.3681 2.66666 9.99992 2.66666ZM3.33325 3.99999C2.96506 3.99999 2.66659 3.70152 2.66659 3.33333C2.66659 2.96514 2.96506 2.66666 3.33325 2.66666C3.70144 2.66666 3.99992 2.96514 3.99992 3.33333C3.99992 3.70152 3.70144 3.99999 3.33325 3.99999ZM5.99992 3.99999C5.63173 3.99999 5.33325 3.70152 5.33325 3.33333C5.33325 2.96514 5.63173 2.66666 5.99992 2.66666C6.36811 2.66666 6.66658 2.96514 6.66658 3.33333C6.66658 3.70152 6.36811 3.99999 5.99992 3.99999ZM8.66658 3.99999C8.2984 3.99999 7.99992 3.70152 7.99992 3.33333C7.99992 2.96514 8.2984 2.66666 8.66658 2.66666C9.03477 2.66666 9.33325 2.96514 9.33325 3.33333C9.33325 3.70152 9.03477 3.99999 8.66658 3.99999ZM9.99992 5.33333C9.63173 5.33333 9.33325 5.03485 9.33325 4.66666C9.33325 4.29847 9.63173 3.99999 9.99992 3.99999C10.3681 3.99999 10.6666 4.29847 10.6666 4.66666C10.6666 5.03485 10.3681 5.33333 9.99992 5.33333ZM7.33325 5.33333C6.96506 5.33333 6.66658 5.03485 6.66658 4.66666C6.66658 4.29847 6.96506 3.99999 7.33325 3.99999C7.70144 3.99999 7.99992 4.29847 7.99992 4.66666C7.99992 5.03485 7.70144 5.33333 7.33325 5.33333ZM4.66659 5.33333C4.2984 5.33333 3.99992 5.03485 3.99992 4.66666C3.99992 4.29847 4.2984 3.99999 4.66659 3.99999C5.03477 3.99999 5.33325 4.29847 5.33325 4.66666C5.33325 5.03485 5.03477 5.33333 4.66659 5.33333ZM1.99992 5.33333C1.63173 5.33333 1.33325 5.03485 1.33325 4.66666C1.33325 4.29847 1.63173 3.99999 1.99992 3.99999C2.36811 3.99999 2.66659 4.29847 2.66659 4.66666C2.66659 5.03485 2.36811 5.33333 1.99992 5.33333ZM3.33325 6.66666C2.96506 6.66666 2.66659 6.36818 2.66659 5.99999C2.66659 5.6318 2.96506 5.33333 3.33325 5.33333C3.70144 5.33333 3.99992 5.6318 3.99992 5.99999C3.99992 6.36818 3.70144 6.66666 3.33325 6.66666ZM5.99992 6.66666C5.63173 6.66666 5.33325 6.36818 5.33325 5.99999C5.33325 5.6318 5.63173 5.33333 5.99992 5.33333C6.36811 5.33333 6.66658 5.6318 6.66658 5.99999C6.66658 6.36818 6.36811 6.66666 5.99992 6.66666ZM8.66658 6.66666C8.2984 6.66666 7.99992 6.36818 7.99992 5.99999C7.99992 5.6318 8.2984 5.33333 8.66658 5.33333C9.03477 5.33333 9.33325 5.6318 9.33325 5.99999C9.33325 6.36818 9.03477 6.66666 8.66658 6.66666ZM9.99992 7.99999C9.63173 7.99999 9.33325 7.70152 9.33325 7.33333C9.33325 6.96514 9.63173 6.66666 9.99992 6.66666C10.3681 6.66666 10.6666 6.96514 10.6666 7.33333C10.6666 7.70152 10.3681 7.99999 9.99992 7.99999ZM7.33325 7.99999C6.96506 7.99999 6.66658 7.70152 6.66658 7.33333C6.66658 6.96514 6.96506 6.66666 7.33325 6.66666C7.70144 6.66666 7.99992 6.96514 7.99992 7.33333C7.99992 7.70152 7.70144 7.99999 7.33325 7.99999ZM4.66659 7.99999C4.2984 7.99999 3.99992 7.70152 3.99992 7.33333C3.99992 6.96514 4.2984 6.66666 4.66659 6.66666C5.03477 6.66666 5.33325 6.96514 5.33325 7.33333C5.33325 7.70152 5.03477 7.99999 4.66659 7.99999ZM1.99992 7.99999C1.63173 7.99999 1.33325 7.70152 1.33325 7.33333C1.33325 6.96514 1.63173 6.66666 1.99992 6.66666C2.36811 6.66666 2.66659 6.96514 2.66659 7.33333C2.66659 7.70152 2.36811 7.99999 1.99992 7.99999Z",
    fill: "url(#paint3_linear_1310_7981)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1310_7981",
    x1: 13.9998,
    y1: 0,
    x2: 13.9998,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1310_7981",
    x1: 13.9998,
    y1: 0,
    x2: 13.9998,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D02F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B12537"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1310_7981",
    x1: 5.99976,
    y1: 0,
    x2: 5.99976,
    y2: 9.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46467F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1310_7981",
    x1: 5.99992,
    y1: 1.33333,
    x2: 5.99992,
    y2: 7.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_7981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.08869548213416ae5d61b14606aef6e6.svg";
export { ForwardRef as ReactComponent };